module.exports = new __parcel__URL__("permissions-gate.c41aa8ae.svg").toString();